<template>
  <div class="collection-main-layout">
    <section class="collection-content">
      <div v-if="isNum == 1" class="collection-list">
        <div
          class="collection-card"
          v-for="(item, index) in clearList"
          :key="index"
          @click="goDetail(item)"
          style="cursor:pointer;"
        >
          <div class="collection-cover">
            <img :src="getImg(item)" :alt="item.name" />
            <div class="collection-action" @click.stop>
              <el-tooltip content="取消收藏" placement="top">
                <el-button
                  icon="el-icon-delete"
                  circle
                  size="small"
                  @click="cancel(item)"
                ></el-button>
              </el-tooltip>
            </div>
            <div class="collection-meta-bottom">
              <span class="collection-meta-item"
                ><i class="iconfont iconai-eye"></i>{{ item.pv }}</span
              >
              <span class="collection-meta-item"
                ><i class="iconfont iconaixin"></i>{{ item.laud }}</span
              >
            </div>
          </div>
          <div class="collection-info">
            <div class="collection-title-row">
              <el-tooltip :content="item.name" placement="top">
                <span class="collection-title">{{ item.name }}</span>
              </el-tooltip>
              <span
                class="collection-type"
                :class="getModuleClass(item.module, item.type)"
                >{{ getModuleName(item.module, item.type) }}</span
              >
            </div>
            <div class="collection-date-row">
              <span class="collection-date">{{ item.time }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="collection-empty" v-else>
        <img
          v-if="showEmptyImg"
          src="https://img.icons8.com/ios/452/nothing-found.png"
          alt="暂无收藏"
          class="collection-empty-img"
        />
        <div class="collection-empty-title">还没有收藏模板</div>
        <router-link :to="{ name: 'indexPage' }">
          <el-button type="primary">去首页看看</el-button>
        </router-link>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      clearList: [],
      clearLists: [],
      isNum: 0,
      showEmptyImg: false
    };
  },
  methods: {
    getImg(item) {
      let img = item.cover || item.image || "";
      if (img && img.indexOf(",") !== -1) {
        img = img.split(",")[0];
      }
      return img;
    },
    getModuleClass(module, type) {
      const classMap = {
        'chuangxin': 'type-chuangxin',
        'ppt': 'type-ppt',
        'word': 'type-word',
        'zygh': 'type-zygh',
        'datiao': 'type-datiao',
        'xiaotiao': 'type-xiaotiao'
      };
      return classMap[module] || 'type-default';
    },
    getModuleName(module, type) {
      const nameMap = {
        'chuangxin': '创新大赛',
        'ppt': '新文科PPT',
        'word': '新文科Word',
        'zygh': '职业规划',
        'datiao': '大挑',
        'xiaotiao': '小挑'
      };
      return nameMap[module] || '未知模块';
    },
    goDetail(item) {
      let link;
      switch (item.module) {
        case 'chuangxin':
          // 创新大赛模块 - 跳转到详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
        case 'ppt':
        case 'word':
          // 新文科PPT/Word模块 - 跳转到新文科详情页
          link = this.$router.resolve({
            name: "XinWenKeDetail",
            query: { code: item.code }
          });
          break;
        case 'zygh':
          // 职业规划模块 - 跳转到详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
        case 'datiao':
          // 大挑模块 - 跳转到大挑详情页
          link = this.$router.resolve({
            name: "BigChallengeDetail",
            query: { code: item.code }
          });
          break;
        case 'xiaotiao':
          // 小挑模块 - 跳转到小挑详情页
          link = this.$router.resolve({
            name: "SmallChallengeDetail",
            query: { code: item.code }
          });
          break;
        default:
          // 默认跳转到传统详情页
          link = this.$router.resolve({
            name: "Detailspage",
            query: { type: item.type, code: item.code }
          });
          break;
      }
      window.open(link.href, "_blank");
    },
    download() {
      this.axios
        .mylike({
          params: {
            token: this.$store.state.token
          }
        })
        .then(res => {
          if (res.data.code == 200) {
            var arr = [];
            // 处理所有模块的数据
            if (res.data.data.chuangxin && res.data.data.chuangxin.rows) {
              arr = arr.concat(res.data.data.chuangxin.rows.map(item => ({ ...item, module: 'chuangxin' })));
            }
            if (res.data.data.ppt && res.data.data.ppt.rows) {
              arr = arr.concat(res.data.data.ppt.rows.map(item => ({ ...item, module: 'ppt' })));
            }
            if (res.data.data.word && res.data.data.word.rows) {
              arr = arr.concat(res.data.data.word.rows.map(item => ({ ...item, module: 'word' })));
            }
            if (res.data.data.zygh && res.data.data.zygh.rows) {
              arr = arr.concat(res.data.data.zygh.rows.map(item => ({ ...item, module: 'zygh' })));
            }
            if (res.data.data.datiao && res.data.data.datiao.rows) {
              arr = arr.concat(res.data.data.datiao.rows.map(item => ({ ...item, module: 'datiao' })));
            }
            if (res.data.data.xiaotiao && res.data.data.xiaotiao.rows) {
              arr = arr.concat(res.data.data.xiaotiao.rows.map(item => ({ ...item, module: 'xiaotiao' })));
            }

            // 处理图片字段
            arr.forEach(item => {
              if (!item.cover && item.image) item.cover = item.image;
            });

            this.clearList = arr;
            if (this.clearList.length != 0) {
              this.isNum = 1;
              this.showEmptyImg = false;
            } else {
              this.isNum = 2;
              setTimeout(() => {
                this.showEmptyImg = true;
              }, 100);
            }
          } else {
            this.clearList = [];
            this.isNum = 2;
            setTimeout(() => {
              this.showEmptyImg = true;
            }, 100);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //取消收藏
    cancel(item) {
      let axiosMethod;
      switch (item.module) {
        case 'chuangxin':
          // 创新大赛模块使用传统收藏接口
          axiosMethod = this.axios.collectionlike;
          break;
        case 'ppt':
        case 'word':
          // 新文科PPT/Word模块使用新文科收藏接口
          axiosMethod = this.axios.likeXinWenKeFile;
          break;
        case 'zygh':
          // 职业规划模块使用传统收藏接口
          axiosMethod = this.axios.collectionlike;
          break;
        case 'datiao':
          // 大挑模块使用大挑收藏接口
          axiosMethod = this.axios.collectionlike;
          break;
        case 'xiaotiao':
          // 小挑模块使用小挑收藏接口
          axiosMethod = this.axios.collectionlike;
          break;
        default:
          // 默认使用传统收藏接口
          axiosMethod = this.axios.collectionlike;
          break;
      }

      axiosMethod.call(this.axios, {
        token: this.$store.state.token,
        code: item.code,
        state: "f"
      })
      .then(res => {
        if (res.data.code == 200) {
          this.download();
        }
      })
      .catch(err => {
        console.log(err);
      });
    }
  },
  mounted() {
    this.download();
  }
};
</script>
<style scoped>
.collection-main-layout {
  display: flex;
  height: 100vh;
  background: #f7f8fa;
}
.collection-content {
  flex: 1;
  overflow-y: auto;
  padding: 36px 32px 32px 32px;
  min-width: 0;
}
.collection-list {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 10px;
}
.collection-card {
  background: #fafbfc;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s, background 0.2s, border-color 0.2s;
  border: 1.5px solid #f3f3f3;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.collection-card:hover {
  background: #eaf6fd;
  box-shadow: 0 8px 32px rgba(88, 171, 224, 0.18);
  border-color: #58abe0;
  z-index: 2;
}
.collection-cover {
  width: 100%;
  aspect-ratio: 16/10;
  background: #f0f2f5;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.collection-cover img {
  width: 95%;
  height: 95%;
  object-fit: contain;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: none;
  background: #fff;
}
.collection-action {
  position: absolute;
  right: 16px;
  bottom: 12px;
  z-index: 2;
  opacity: 0;
  transition: opacity 0.2s;
  display: flex;
  align-items: center;
  gap: 6px;
}
.collection-card:hover .collection-action {
  opacity: 1;
}
.collection-action .el-button {
  background: linear-gradient(90deg, #f1787f 0%, #f7b267 100%);
  color: #fff;
  font-weight: 700;
  border: none;
  box-shadow: 0 2px 8px rgba(241, 120, 127, 0.1);
  transition: background 0.2s, box-shadow 0.2s;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.collection-action .el-button:hover {
  background: linear-gradient(90deg, #f7b267 0%, #f1787f 100%);
  box-shadow: 0 4px 16px rgba(241, 120, 127, 0.18);
}
.collection-action .collection-btn-text {
  display: none;
}
.collection-info {
  padding: 18px 18px 0 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.collection-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 2px;
}
.collection-title {
  font-size: 16px;
  font-weight: 500;
  color: #222;
  line-height: 1.2;
  margin-right: 8px;
  transition: color 0.2s;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  vertical-align: bottom;
}
.collection-title:hover {
  color: #f1787f;
}
.collection-type {
  font-size: 13px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 10px;
  background: #fdeaf3;
  color: #f1787f;
  margin-left: 6px;
}
.type-word {
  background: #f8eafc;
  color: #b958e0;
}
.type-xwk {
  background: #e8f4fd;
  color: #1890ff;
}
.type-chuangxin {
  background: #fff2e8;
  color: #fa541c;
}
.type-zygh {
  background: #f6ffed;
  color: #52c41a;
}
.type-datiao {
  background: #fff1f0;
  color: #f5222d;
}
.type-xiaotiao {
  background: #f9f0ff;
  color: #722ed1;
}
.type-default {
  background: #f5f5f5;
  color: #666;
}
.collection-meta-row {
  display: flex;
  align-items: center;
  gap: 18px;
  font-size: 14px;
  color: #888;
}
.collection-date {
  color: #aaa;
  font-size: 13px;
  min-width: 90px;
  text-align: left;
}
.collection-meta {
  display: flex;
  align-items: center;
  gap: 4px;
}
.collection-meta-bottom {
  position: absolute;
  left: 16px;
  bottom: 14px;
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 10px;
  z-index: 2;
}
.collection-meta-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #888;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 12px;
  padding: 2px 10px 2px 7px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  font-weight: 500;
}
.collection-meta-item i {
  font-size: 16px;
  margin-right: 4px;
  color: #f1787f;
}
.collection-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 320px;
  width: 100%;
  background: #f8f8fa;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 32px 0;
}
.collection-empty-img {
  width: 150px;
  margin-bottom: 18px;
  opacity: 0.85;
}
.collection-empty-title {
  font-size: 20px;
  font-weight: 600;
  color: #222;
  margin-bottom: 6px;
}
.collection-date-row {
  margin-bottom: 8px;
  color: #aaa;
  font-size: 13px;
}
@media (max-width: 900px) {
  .collection-main-layout {
    flex-direction: column;
  }
  .collection-aside {
    width: 100%;
    min-width: 0;
    height: auto;
    box-shadow: none;
    border-bottom: 1px solid #f3f3f3;
  }
  .collection-header-fixed {
    padding: 24px 0 12px 0;
    font-size: 22px;
  }
  .collection-content {
    padding: 16px 2vw 16px 2vw;
    max-width: 98vw;
  }
  .collection-list {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
</style>
